export default "__VITE_ASSET__DGPXAx1M__"